import { Injectable } from '@angular/core';
import { Partner } from '../interfaces/partner';

@Injectable({
  providedIn: 'root'
})
export class StorePartnerService {

  constructor() { }
  storedPartner!: Partner;

  setVar(partner:Partner){
    this.storedPartner = partner;
  }
}
